<template>
  <PageBreadcrumb
    :crumbs="[{
      link: '/aste/',
      label: 'Gestione Aste'
    }, {
      label: 'Gestione Lotti Asta ' + auction.name
    }]"
  />

  <div class="flex justify-between mb-4">
    <div class="flex-grow">
      <SearchInput v-model="search" />
      <SearchSelect
        v-model="product"
        name="product-status"
        :options="productsMap"
      />
    </div>
  </div>

  <DataTable :data="data">
    <template #heading>
      <tr>
        <SortableColumn
          v-model="sortStatus"
          name="product"
        >
          Prodotto
        </SortableColumn>
        <SortableColumn
          v-model="sortStatus"
          name="quantity"
        >
          Quantità
        </SortableColumn>
        <SortableColumn
          v-model="sortStatus"
          name="price"
        >
          Prezzo
        </SortableColumn>
        <SortableColumn
          v-model="sortStatus"
          name="selectedAt"
        >
          Data
        </SortableColumn>
        <SortableColumn
          v-model="sortStatus"
          name="selectedByUserEmail"
        >
          Utente
        </SortableColumn>
        <SortableColumn
          v-model="sortStatus"
          name="selectedByCompanyName"
        >
          Partecipante
        </SortableColumn>
        <SortableColumn
          v-model="sortStatus"
          name="selectedByBottlerName"
        >
          Imbottigliatore
        </SortableColumn>
      </tr>
    </template>
    <template #body>
      <tr
        v-for="lot in data"
        :key="'lot-table-tr-' + lot.uuid"
        class="odd:bg-gray-100"
      >
        <td class="p-2">
          {{ productsMap[lot.productUuid] }}
        </td>
        <td class="p-2">
          {{ lot.quantity }}
        </td>
        <td class="p-2">
          {{ lot.price }}
        </td>
        <td class="p-2">
          {{ formatLong(lot.selectedAt) }}
        </td>
        <td class="p-2">
          {{ lot.selectedByUserEmail }}
        </td>
        <td class="p-2">
          {{ lot.selectedByCompanyName }}
        </td>
        <td class="p-2">
          {{ lot.selectedByBottlerName }}
        </td>
      </tr>
    </template>
  </DataTable>

  <DataTablePaginator
    :count="count"
    :count-all="countAll"
    :count-filtered="countFiltered"
    :current-page="currentPage"
    :has-next="hasNext"
    :has-prev="hasPrev"
    :next="next"
    :prev="prev"
    :total-pages="totalPages"
  />
</template>

<script setup>
import { ref, watch } from "vue";
import { useRoute, useRouter } from 'vue-router';

import DataTable from "@/components/list/DataTable.vue";
import DataTablePaginator from "@/components/list/DataTablePaginator.vue";
import SearchInput from "@/components/list/SearchInput.vue";
import SearchSelect from "@/components/list/SearchSelect.vue";
import SortableColumn from "@/components/list/SortableColumn.vue";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useAxios from '@/composables/axios.js'
import useDataTable from '@/composables/datatable.js'
import { formatLong } from "@/services/date";

const search = ref('')
const product = ref();

const sortStatus = ref(["position", -1]);

const route = useRoute()
const axios = useAxios()

const auctionId = route.params.auctionId
const auctionResp = await axios.get('/auction/' + auctionId);
const auction = ref(auctionResp.data);

const productResp = await axios.get('/product/list')
const productsMap = productResp.data.reduce((productsMap, product) => {
  productsMap[product.uuid] = product.code;
  return productsMap;
}, {})

const { data, count, countFiltered, countAll, currentPage, totalPages, next, prev, hasPrev, hasNext, doFilter} = await useDataTable({
  endpoint: "/lot-redistribute/summary/" + auctionId,
  sortStatus,
  search,
  searchProperties: ['selectedByUserEmail', 'selectedByCompanyName', 'selectedByBottlerName'],
  extraFilter: (item) => {
    console.log(product.value, item.productUuid);
    return (product.value ? item.productUuid == product.value : true)
  }
})

watch(product, () => {
  doFilter()
})

</script>
